/**
 * @deprecated use OrderRefundedStatus
 */
export enum RefundedStatus {
  TOTALLY_REFUNDED = 'TOTALLY_REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  NOT_REFUNDED = 'NOT_REFUNDED',
}
